var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-footer"},[_vm._v("\n  Registros: "+_vm._s(_vm.lengthElements)+" de "+_vm._s(_vm.totalElements)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }